import { createFileRoute, redirect } from "@tanstack/react-router";
import { NewWarehouseOrder } from "@/features/warehouseOrders/NewWarehouseOrder";
import { hasModule, firstAllowedRoute } from "@/lib/auth";

// Transport → Magazijnorders → Nieuwe magazijnorder (docs/partner-portal.md §16 step 8): a screen of its own, as a new
// order has one. Typing one is tms_orders_write; a reader goes back to the list.
export const Route = createFileRoute("/_shell/warehouse-orders_/new")({
  beforeLoad: ({ context }) => {
    if (context.session.roles.includes("admin") || hasModule(context.session, "tms_orders_write")) return;
    if (hasModule(context.session, "tms_orders")) throw redirect({ to: "/warehouse-orders" });
    throw redirect({ to: firstAllowedRoute(context.session) });
  },
  // From the invoerbak: the row and which of its proposed orders (docs/invoerbak.md §4a).
  validateSearch: (search: Record<string, unknown>): { intake?: string; order?: number } => ({
    ...(typeof search["intake"] === "string" && search["intake"] ? { intake: search["intake"] } : {}),
    ...(search["order"] !== undefined && Number.isInteger(Number(search["order"])) ? { order: Number(search["order"]) } : {}),
  }),
  component: NewWarehouseOrderScreen,
});

function NewWarehouseOrderScreen() {
  const search = Route.useSearch();
  return <NewWarehouseOrder {...(search.intake ? { fromIntake: { itemId: search.intake, index: search.order ?? 0 } } : {})} />;
}
